import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ReportingService} from '../../services/reporting.service';
import {DialogService} from '../../services/dialog.service';
import {extractErrorMessage} from '../../utils/error-utils';
import {PolicyType} from '../../constants/retention-constants';

@Component({
  selector: 'app-alert-quarter',
  templateUrl: './alert-quarter.component.html',
  styleUrls: ['./alert-quarter.component.scss']
})
export class AlertQuarterComponent implements OnInit {

  public reportDownloadUrl: string;

  constructor(private reportService: ReportingService,
              private dialogService: DialogService,
              @Inject(MAT_DIALOG_DATA) private data: { isFinra: boolean }) {
  }

  ngOnInit(): void {
    const retentionType = this.data.isFinra ? PolicyType.FINRA : PolicyType.STANDARD;
    this.reportService.loadLatestWarnNotificationReportDetails(retentionType).subscribe({
      next: resp => this.reportDownloadUrl = resp.reportGcsPath,
      error: error => this.dialogService.error(extractErrorMessage(error))
    });
  }

}
